/*eslint backbone/no-constructor:0 */
define('glu/grid/row/row',['require','../../itemView','../../$','./../cell/rowSelectorCell','./../cell/singleRowSelectorCell','./../cell/imageCell','./../cell/rowButtons','../../util','../../model','../../log'],function(require) {
    'use strict';

    var ItemView = require('../../itemView'),
        $ = require('../../$'),
        RowSelectorCell = require('./../cell/rowSelectorCell'),
        SingleRowSelectorCell = require('./../cell/singleRowSelectorCell'),
        RowImageCell = require('./../cell/imageCell'),
        RowButtons = require('./../cell/rowButtons'),
        util = require('../../util'),
        Model = require('../../model'),
        log = require('../../log');

    function getClassName(column, model, val) {
        var className = column.get('className');
        if (util.isFunction(className)) {
            className = className(val, model);
        }
        return className;
    }

    return ItemView.extend({
        modelEvents: {
            'change': 'renderAndRestoreFocus'
        },

        tagName: 'tr',
        cellViewPrefix: 'cellview',
        template: function() {
            return '';
        },

        constructor: function(options) {
            var className = options.rowClassName;
            this.gridCid = options.gridCid;

            if (className) {
                this.className = util.isFunction(className) ?
                    className(options.model) :
                    className;
            }

            ItemView.prototype.constructor.apply(this, arguments);
        },

        initialize: function(options) {
            ItemView.prototype.initialize.call(this, options);
            this.columns = options.columns;
            this.columnViews = [];
        },

        onRender: function() {
            this.showColumns();
            this.$el.attr('data-model-cid', this.model.cid);
        },

        onBeforeClose: function() {
            this.closeColumns();
        },

        closeColumns: function() {
            util.each(this.columnViews, function(columnView) {
                columnView.close();
            });
            this.columnViews = [];
        },

        getValue: function(column) {
            if (!column.has('field')) {
                return '';
            }

            var baseValue = this.model.get(column.get('field'));

            if (baseValue === null || baseValue === undefined) {
                return column.get('defaultValue') || baseValue;
            }

            var str = baseValue.toString();
            var val = baseValue.valueOf();

            if (!this.model.editRow && util.isFunction(column.get('format'))) {
                str = column.get('format')(val, this.model);
            }

            // Safe mode should be enforced by default.
            if (column.get('safe') !== false) {
                str = util.escape(str);
            }

            return str;
        },

        getTableCell: function() {
            return $('<td></td>'); // eslint-disable-line backbone/no-native-jquery
        },

        showColumns: function() {
            this.closeColumns();
            this.columns.each(this.showColumn, this);
        },

        showSimpleCell: function(column) {
            var val = this.getValue(column);

            if (util.isNull(val) || util.isUndefined(val)) {
                val = '';
            }

            var $td = this.getTableCell();

            $td.append(val.toString());
            var className = getClassName(column, this.model, val);
            if (className) {
                $td.addClass(className);
            }

            var dataTitle;
            if (column.get('safe') === false) {
                try {
                    dataTitle = $(val).text(); // eslint-disable-line backbone/no-native-jquery
                } catch (e) {
                    dataTitle = val;
                }
            }

            // required syntax for [data-title] selector to work in events
            $td.attr('data-title', (dataTitle ? dataTitle : val));

            this.el.appendChild($td[0]);
        },

        showAnchorCell: function(column) {
            var urlProperty = column.get('url'),
                val = this.getValue(column),
                url = util.isFunction(urlProperty) ? urlProperty(this.model, column) : urlProperty,
                $td = this.getTableCell(),
                $a;

            if (url && val) {
                $a = $('<a href="' + url + '"/>'); // eslint-disable-line backbone/no-native-jquery


                //use `html()` instead of `text()` because value is already escaped in `getValue()` above.
                $a.append($('<span />').html(val)); // eslint-disable-line backbone/no-native-jquery

                $td.append($a);
            } else {
                $td.text(val || '');
            }

            $td.attr('data-title', val);

            var className = getClassName(column, this.model, val);
            if (className) {
                $td.addClass(className);
            }

            this.el.appendChild($td[0]);
        },

        showRowSelectorCell: function(column) {
            var val = this.getValue(column),
                $td = this.getTableCell();

            var inst = new RowSelectorCell({
                el: $td,
                column: column,
                model: this.model,
                value: val,
                grid: this.options.grid,
                gridCid: this.gridCid
            });

            inst.render();

            var className = getClassName(column, this.model, val);
            if (className) {
                $td.addClass(className);
            }

            $td.append(inst.el);

            this.el.appendChild($td[0]);

            return inst;
        },

        showSingleRowSelectorCell: function(column) {
            var val = this.getValue(column),
                $td = this.getTableCell();

            var inst = new SingleRowSelectorCell({
                el: $td,
                column: column,
                model: this.model,
                value: val
            });

            inst.render();

            var className = getClassName(column, this.model, val);
            if (className) {
                $td.addClass(className);
            }

            $td.append(inst.el);

            this.el.appendChild($td[0]);

            return inst;
        },

        showImageCell: function(column) {
            var inst;

            if (!column.has('field')) {
                return '';
            }
            var $td = this.getTableCell();

            var imageData = this.model.get(column.get('field'));
            var url;

            //get our value and make sure it's an object
            if (imageData !== undefined && !util.isArray(imageData)) {

                //convert our object data into a model
                var model = new Model(imageData);

                //if we have a format function , use that value for the image src
                var urlProperty = column.get('formatSrc');

                url = util.isFunction(urlProperty) ? urlProperty(imageData, this.model) : undefined;

                //if we have a formatted image path set, use this for an image.
                if (url !== undefined) {
                    model.set('src', url);
                }

                //render our image tag in the cell
                inst = new RowImageCell({
                    el: $td,
                    column: column,
                    model: model
                });

                inst.render();
                $td.append(inst.el);
            }

            var className = getClassName(column, this.model, url);
            if (className) {
                $td.addClass(className);
            }

            this.el.appendChild($td[0]);

            return inst;
        },

        showRowButtons: function(column) {
            var view = new RowButtons({
                tagName: 'td',
                className: 'grid-row-buttons',
                model: this.model,
                column: column,
                gridCid: this.gridCid
            });

            view.render();

            this.el.appendChild(view.el);
            this.$el.width(view.$el.outerWidth());

            return view;
        },

        showCustomCellView: function(CellView, column, cellViewOptions) {
            var viewOptions = util.extend({
                tagName: 'td',
                model: this.model,
                column: column,
                value: this.getValue(column)
            }, cellViewOptions);

            var view = new CellView(viewOptions);

            view.render();

            this.listenTo(view, 'all', this.handleCellEvent);

            this.el.appendChild(view.el);

            return view;
        },

        showColumn: function(column) {
            var columnView;

            if (column.has('condition')) {
                var isFunction = util.isFunction(column.get('condition')) && !column.get('condition')(this.model, column);
                var isBoolean = util.isBoolean(column.get('condition')) && !column.get('condition');
                if (isFunction || isBoolean) {
                    return;
                }
            }

            if (column.has('rowButtons')) {
                columnView = this.showRowButtons(column);
            } else if (column.has('cellView')) {
                columnView = this.showCustomCellView(column.get('cellView'), column, column.get('cellViewOptions'));
            } else if (util.isFunction(column.get('type'))) {
                log.warn('Passing a function to column.type in the grid is deprecated. Change "type" to "cellView".');
                columnView = this.showCustomCellView(column.get('type'), column, column.get('cellViewOptions'));
            } else if (column.has('url')) {
                this.showAnchorCell(column);
            } else if (column.get('type') === 'rowSelector') {
                columnView = this.showRowSelectorCell(column);
            } else if (column.get('type') === 'singleRowSelector') {
                columnView = this.showSingleRowSelectorCell(column);
            } else if (column.get('type') === 'image') {
                columnView = this.showImageCell(column);
            } else {
                this.showSimpleCell(column);
            }

            if (columnView) {
                this.columnViews.push(columnView);
            }

            if (!this.options.disableDynamicColumnWidths) {
                var $lastAddedTd = this.$('> td').last(),
                    $correspondingTh = this.$el.parents('.grid .js-canvas > table').find('thead th').eq($lastAddedTd.index()),
                    data = $correspondingTh.data(),
                    columnWidth = data ? data.initialWidth : 'auto';

                $lastAddedTd.css({
                    width: columnWidth,
                    minWidth: columnWidth,
                    maxWidth: columnWidth
                });
            }
        },

        handleCellEvent: function(name, view, e) {
            this.trigger(name, this, view, e);
        }
    });
});

